import { EPortfolioManagementTabs } from '../enums/EPortfolioManagementTabs';
import { PageRoutes } from '../enums/enums';

export const operationsSections = {
  [EPortfolioManagementTabs.PERFORMANCE]: {
    path: PageRoutes.OPS_NEWS_PERFORMANCE,
    dictKey: 'portfolioManagement.nav.performance'
  },
  [EPortfolioManagementTabs.HEDGE]: {
    path: PageRoutes.OPS_NEWS_HEDGE,
    dictKey: 'portfolioManagement.nav.hedge'
  },
  [EPortfolioManagementTabs.EVENTS]: {
    path: PageRoutes.OPS_NEWS_EVENTS,
    dictKey: 'portfolioManagement.nav.events'
  },
  [EPortfolioManagementTabs.MISC]: {
    path: PageRoutes.OPS_NEWS_MISC,
    dictKey: 'portfolioManagement.nav.misc'
  },
  [EPortfolioManagementTabs.ORDERS]: {
    path: PageRoutes.OPS_NEWS_ORDERS,
    dictKey: 'portfolioManagement.nav.orders'
  }
};
